import { useCallback } from 'react'
import { DAY, type ChatGetSuccess, type ChatGetInput, type AiChatData } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { useTantalimQuery } from '../query'
import { chatGetKey } from '../keys'
import type { GetHookResponse } from '../hooks'
import { useServerRequest } from '../api'

export function useChat(sessionId: string, enabled: boolean): GetHookResponse<AiChatData> {
  return useTantalimQuery<ChatGetInput, ChatGetSuccess, AiChatData>({
    url: '/ai/chat/get',
    queryKey: chatGetKey(sessionId),
    input: {
      sessionId,
    },
    convertResponse: (data) => data.chat,
    options: {
      gcTime: DAY,
      staleTime: DAY,
      enabled,
    },
  })
}

export function usePrefetchChat(): (sessionId: string) => Promise<void> {
  const serverRequest = useServerRequest<ChatGetInput, ChatGetSuccess>('/ai/chat/get')
  const queryClient = useQueryClient()
  return useCallback(
    async (sessionId: string): Promise<void> => {
      await queryClient.prefetchQuery({
        queryKey: chatGetKey(sessionId),
        queryFn: async () => {
          const res = await serverRequest({ sessionId })
          return res.chat
        },
      })
    },
    [queryClient, serverRequest]
  )
}
